import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MultiSelectTicketRow } from '../detaille-multi-selection-ticket/detaille-multi-selection-ticket.component';

@Component({
  selector: 'app-annuler-multi-ticket-modal',
  templateUrl: './annuler-multi-ticket-modal.component.html',
  styleUrls: ['./annuler-multi-ticket-modal.component.scss'],
})
export class AnnulerMultiTicketModalComponent implements OnChanges {
  @Input() ticketIds: number[] = [];
  @Input() isAdmin = true;
  @Input() submitting = false;
  @Output() closed = new EventEmitter<void>();
  @Output() confirmCancel = new EventEmitter<{
    ticketIds: number[];
    allowPaidCancel: boolean;
  }>();

  step: 'list' | 'confirm' = 'list';
  rows: MultiSelectTicketRow[] = [];
  canProceed = false;

  get allowPaidCancel(): boolean {
    return this.isAdmin;
  }

  get selectedIds(): number[] {
    return this.rows.map((r) => r.id);
  }

  get hasAdminTickets(): boolean {
    return this.rows.some((r) => r.requiresAdmin);
  }

  get hasBlockedTickets(): boolean {
    return this.rows.some((r) => !r.canCancel);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ticketIds'] && !changes['ticketIds'].firstChange) {
      this.step = 'list';
      this.rows = [];
      this.canProceed = false;
    }
  }

  onRowsChange(rows: MultiSelectTicketRow[]): void {
    this.rows = rows;
  }

  onCanProceedChange(can: boolean): void {
    this.canProceed = can;
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  onPanelClick(event: Event): void {
    event.stopPropagation();
  }

  onClose(): void {
    if (this.submitting) {
      return;
    }
    this.closed.emit();
  }

  onSuivant(): void {
    if (!this.canProceed || this.rows.length === 0) {
      return;
    }
    this.step = 'confirm';
  }

  onRetour(): void {
    this.step = 'list';
  }

  onConfirm(): void {
    if (!this.canProceed || this.submitting) {
      return;
    }
    this.confirmCancel.emit({
      ticketIds: this.selectedIds,
      allowPaidCancel: this.allowPaidCancel && this.hasAdminTickets,
    });
  }
}
